import styled from "@emotion/styled";
import { Form, Input } from "antd";
import { useEffect } from "react";

import { SYSTEM_ATTRIBUTE_PROPERTY } from "~/core/constants/attributes";

import { useGlobalNewOpportunityModalContext } from "../../context";
import { useInputKeyDown } from "../../hooks/useInputKeyDown";
import { useGlobalCreateOpportunityStore } from "../../store";

const StyledRequiredFormItem = styled(Form.Item)`
  .ant-form-item-required {
    flex-direction: row-reverse;
    ::after {
      display: none;
    }
  }
`;

export const OpportunityName = () => {
  const isOpen = useGlobalCreateOpportunityStore(
    state => state.isOpenGlobalCreateOpportunity,
  );
  const { handleKeyDown } = useInputKeyDown();
  const { oppNameRef } = useGlobalNewOpportunityModalContext();

  useEffect(() => {
    if (isOpen && oppNameRef?.current) {
      // Use requestAnimationFrame to ensure DOM is ready
      requestAnimationFrame(() => {
        oppNameRef?.current?.focus();
      });
    }
  }, [isOpen, oppNameRef]);

  return (
    <StyledRequiredFormItem
      name={SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_NAME}
      label={"Opportunity name (required)"}
      rules={[
        {
          required: true,
          message: "Opportunity name is required",
        },
      ]}
    >
      <Input
        placeholder="Enter opportunity name"
        ref={oppNameRef}
        onKeyDown={handleKeyDown}
      />
    </StyledRequiredFormItem>
  );
};
